import { render } from "./AppSpinner.vue?vue&type=template&id=b2638c18&scoped=true"
import script from "./AppSpinner.vue?vue&type=script&lang=js"
export * from "./AppSpinner.vue?vue&type=script&lang=js"

import "./AppSpinner.vue?vue&type=style&index=0&id=b2638c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2638c18"]])

export default __exports__